import { browser, dev } from '$app/environment';
import { captureException } from '@sentry/sveltekit';

type IntercomAction = 'hide' | 'show' | 'showMessages' | 'shutdown';

export function intercomFn(action: IntercomAction) {
  if (browser && window.Intercom && window.Intercom?.booted) {
    try {
      window.Intercom(action);
    } catch (error) {
      captureException(error);
    }
  } else if (dev) {
    console.info('window.Intercom', action);
  }
}
